module.exports = __webpack_public_path__ + "media/images/vp/icon.fb.white-e2440f92cdd2f3896767034420999306.png";